import { baseCommand } from './basecommand';

type highresshottypename = "highres_shot";

type highresshotdatatype = {
    "width": number,
    "height": number
}

type pscommand<T> = {
    "type": T extends highresshottypename ? T : never;
    "data": T extends highresshottypename ? highresshotdatatype : never;
};

export type highresshotCommand = pscommand<highresshottypename>;

export class highres extends baseCommand {
    public type: highresshottypename = "highres_shot";

    constructor(private x: number, private y: number) {
        super();
    }

    public object(): highresshotCommand {
        return {
            "type" : this.type,
            "data" : {
                "width": this.x,
                "height": this.y
            }
        }
    }
}
